import { render, staticRenderFns } from "./MyTrips.vue?vue&type=template&id=088fab0b&"
import script from "./MyTrips.vue?vue&type=script&lang=ts&"
export * from "./MyTrips.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports